<!-- eslint-disable vue/no-v-html -->
<template>
  <menu-default
    v-if="!mostrarHeaderPersonalizado"
    :logo-empresa="fotoSolicitante"
  />

  <v-layout v-else>
    <v-app-bar
      app
      absolute
      height="85"
      :elevation="1"
    >
      <v-img
        :src="fotoSolicitante"
        max-height="50px"
        max-width="50px"
        alt="logo"
        contain
        class="me-3"
      />

      <div v-html="headerHtml"></div>

      <v-spacer></v-spacer>

      <h3 class="text-2xl font-weight-semibold text--primary">
        {{ tituloHeader }}
      </h3>

      <v-spacer class="mr-15"></v-spacer>

      <app-bar-user-menu />
    </v-app-bar>
  </v-layout>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import AppBarUserMenu from '@core/layouts/components/app-bar/AppBarUserMenu.vue'
import MenuDefault from './MenuDefault.vue'
import DocumentoService from '@/services/modules/DocumentoService'
import useCentralStore from '@/store/central'
import useUserStore from '@/store/user'
import useAuthStore from '@/store/auth'

export default ({
  components: {
    AppBarUserMenu,
    MenuDefault,
  },

  setup() {
    const mostrarHeaderPersonalizado = ref(false)
    const fotoSolicitante = ref('')

    const { tituloHeader, headerHtml, logoId } = storeToRefs(useCentralStore())
    const { isLoggedIn } = storeToRefs(useAuthStore())
    const { empresaId } = storeToRefs(useUserStore())

    async function getLogo() {
      if (!logoId) return
      fotoSolicitante.value = await DocumentoService.getLogoEmpresa(logoId.value, empresaId.value)
    }

    function verificarHTML(script) {
      if (!script) return false

      const scriptTrimmed = script.trim()
      if (scriptTrimmed.startsWith('<')) {
        if (scriptTrimmed.includes('>')) {
          return true
        }
      }

      return false
    }

    async function dadosCanal() {
      mostrarHeaderPersonalizado.value = verificarHTML(headerHtml.value)
      await getLogo()
    }

    watchEffect(async () => {
      if (isLoggedIn.value) {
        await dadosCanal()
      }
    })

    return {
      tituloHeader,
      headerHtml,
      mostrarHeaderPersonalizado,
      fotoSolicitante,
    }
  },
})
</script>
